@for (item of data; track item) {
  <div class="LeaderLine__Data" [ngClass]="{ 't-bold': item.isBold }">
    <div class="LeaderLines__Label">{{ item.label }}</div>
    <div class="Receipt__Divider"></div>
    <div class="LeaderLines__Dots">{{ item.value }}</div>
  </div>
}
